import React, { Component } from 'react';
import Header from '../Layouts/Header'
import Footer from '../Layouts/Footer';
import AuthApi from '../Services/Authapi';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import swal from 'sweetalert';
import TableComponent from '../Layouts/TableComponent';
import Breadcrumb from '../Layouts/Breadcrumb';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import AuthCheckComponent from '../Layouts/Token';
import ClearIcon from "@material-ui/icons/Clear";
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import './Leaves/Leave.css';

class Permission extends Component {
  constructor(props) {
    super(props);
    this.state = {
      permission: [],
      count: 0,
      isLoading: true,
      setopen: false,
      permissionName: false,
      searchQuery: "",
      filteredPermissions: [],
      suggestions: [],
      isPopup: false,
      tableTh: [
        { id: 'name', numeric: false, disablePadding: true, label: 'Name', sortable: true },
        { id: 'created_at', numeric: false, disablePadding: true, label: 'Created On', sortable: true },
        { id: 'actions', numeric: false, disablePadding: true, label: 'Actions', sortable: false }
      ]
    }
    this.permissionData = this.permissionData.bind(this);
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.updatChange = this.updatChange.bind(this);
    this.saveData = this.saveData.bind(this);
    this.removePermission = this.removePermission.bind(this);
    this.updatePermission = this.updatePermission.bind(this);
    this.handleClickOpenUpdate = this.handleClickOpenUpdate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSearchIconClick = this.handleSearchIconClick.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.handleSuggestionClick = this.handleSuggestionClick.bind(this);
  }

  componentDidMount() {
    if (this.props && this.props.authToken === false) {
      this.props.history.push('/login');
    }
    this.permissionData();
  }

  componentWillReceiveProps(props) {
    if (props && props.authToken === false) {
      // props.history.push('/login');
    }
  }

  permissionData = async (e) => {
    this.setState({ isLoading: true });
    let permission = await AuthApi.getPermission();
    if (permission && permission.status === true) {
      this.setState({
        permission: permission.data,
        count: permission.data.length,
        filteredPermissions: permission.data,
        isLoading: false
      });
    } else {
      this.setState({
        permission: [],
        count: 0,
        filteredPermissions: [],
        isLoading: false
      });
    }
  }

  updatePermission = async (id) => {
    let stat = await AuthApi.updatePermission(this.state.permissionName, id);
    if (stat && stat.status === true) {
      this.setState({ setopen: false }, function () {
        this.permissionData();
        swal("Success", "Permission updated successfully!", "success");
      });
    } else {
      // Handle error case
    }
  }

  handleClickOpen(row = false) {
    this.setState({
      setopen: true,
      isPopup: true,
      permissionName: row.name,
    })
  };

  handleClickOpenUpdate(row = false) {
    this.setState({
      setopen: true,
      isPopup: false,
      permissionName: row.name,
      permissionId: row.id,
    })
  };

  handleClose() {
    this.setState({
      setopen: false
    })
  };

  async saveData() {
    if (this.state.isPopup) {
      let currentPermission = await AuthApi.createPermission(this.state.permissionName);
      if (currentPermission && currentPermission.status === true) {
        this.setState({ setopen: false }, function () {
          this.permissionData();
          swal("Success", "Permission created successfully!", "success");
        });
      } else {
        // Handle error case
      }
    } else {
      this.updatePermission(this.state.permissionId);
    }
  }

  async removePermission(id) {
    swal({
      title: "Are you sure?",
      icon: "warning",
      buttons: ["Cancel", "Yes"]
    }).then(async (confirm) => {
      if (confirm) {
        let currentPermission = await AuthApi.deletePermission(id);
        if (currentPermission && currentPermission.status === true) {
          this.permissionData();
          swal("Success", "Permission deleted successfully!", "success");
        } else {
        }
      }
    });
  }

  updatChange(e) {
    this.setState({ permissionName: e.target.value })
  }

  handleChange(e) {
    const searchQuery = e.target.value;
    const suggestions = this.state.permission.filter((item) =>
      item.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    this.setState({ searchQuery, suggestions }, this.handleSearchIconClick);
  }

  handleSearchIconClick() {
    const filterUser = this.state.permission.filter((item) =>
      item.name.toLowerCase().includes(this.state.searchQuery.toLowerCase())
    );
    this.setState({ filteredPermissions: filterUser });
  }

  clearSearch() {
    this.setState({ searchQuery: "", suggestions: [], filteredPermissions: this.state.permission });
  }

  handleSuggestionClick(suggestion) {
    this.setState({ searchQuery: suggestion.name, suggestions: [] }, this.handleSearchIconClick);
  }

  render() {
    const classes = this.props;
    const { filteredPermissions, searchQuery, suggestions } = this.state;
    const permissions = (this.props.authUser && Array.isArray(this.props.authUser.userAccess)) ? this.props.authUser.userAccess : [];
    // console.log(permissions)

    return (
      <div>
        <AuthCheckComponent authToken={this.props.authToken} />
        <Header
          {...this.props}
          authUser={this.props.authUser}
          setAutUser={this.props.setAutUser}
          component={
            <div >
              <div className="holiday-breadcrumb-card">
                <Breadcrumb
                  {...this.props}
                  primaryPageName="Permissions"
                  primaryPageLink="/permission"
                  isSecondaryPage={false}
                  secondaryPageName="" />
              </div>
              <TableComponent
                {...this.props}
                tableTh={this.state.tableTh}
                tableData={filteredPermissions}
                tableCount={filteredPermissions.length}
                isLoading={this.state.isLoading}
                colNameToShow={['name', 'created_at']}
                openPopUp={this.handleClickOpen}
                openPopUpUpdate={this.handleClickOpenUpdate}
                removeRow={this.removePermission}
                actionBtns={[permissions.includes("Permission.Edit") && ('update'), permissions.includes("Permission.Delete") && ('delete')]}
                modelName={'Permission'}
                shellClassName="holiday-table-shell"
                extraHeaderContent={
                  <div className="holiday-toolbar-controls">
                    <div className="holiday-search-wrapper" style={{ marginLeft: "auto" }}>
                      <TextField
                        className="holiday-search-field"
                        label="Search"
                        value={searchQuery}
                        onChange={this.handleChange}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: searchQuery !== "",
                          style: {
                            color: '#036dda',
                            transform: searchQuery !== "" ? 'translate(14px, -6px) scale(0.75)' : 'translate(14px, 11px) scale(1)',
                            transition: 'transform 0.2s ease-in-out'
                          }
                        }}
                        InputProps={{
                          style: {
                            backgroundColor: 'lightgray',
                            borderRadius: '25px',
                            height: "40px"
                          },
                          endAdornment: (
                            <InputAdornment position="end">
                              {searchQuery && (
                                <ClearIcon onClick={this.clearSearch} style={{ cursor: 'pointer' }} />
                              )}
                              <SearchIcon onClick={this.handleSearchIconClick} style={{ cursor: 'pointer' }} />
                            </InputAdornment>
                          ),
                        }}
                      />
                      {searchQuery && suggestions.length > 0 && (
                        <Paper className="holiday-search-suggestions">
                          {[...new Set(suggestions.map(suggestion => suggestion.name))].map((name, index) => (
                            <MenuItem
                              key={index}
                              onClick={() => this.handleSuggestionClick({ name })}
                              style={{
                                padding: '10px 20px',
                                cursor: 'pointer'
                              }}
                            >
                              {name}
                            </MenuItem>
                          ))}
                        </Paper>
                      )}
                    </div>
                  </div>
                }
              />
            </div>
          } />
        <Footer />
        <PopUp
          isPopup={this.state.isPopup}
          {...this.props}
          handleClose={this.handleClose}
          setopen={this.state.setopen} permissionName={this.state.permissionName} saveData={this.saveData} updatChange={this.updatChange} updatePermission={this.updatePermission} />
      </div>
    )
  }
}
export default Permission;

class PopUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.setopen && !prevProps.setopen) {
      this.setState({ submitted: false });
    }
  }

  handleSave = () => {
    this.setState({ submitted: true });
    const name = this.props.permissionName;
    if (name && String(name).trim() !== "") {
      this.props.saveData();
    }
  }

  render() {
    const isNameEmpty = !this.props.permissionName || String(this.props.permissionName).trim() === "";
    const error = this.state.submitted && isNameEmpty;

    return (
      <div>
        <Dialog 
          disableScrollLock={true}
          open={this.props.setopen}
          maxWidth="xs"
          fullWidth
          PaperProps={{
            style: {
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              width: "370px",
            },
          }}
        >
          <div style={{ position: "relative" }}>
            <DialogTitle
              style={{
                textAlign: "center",
                padding: "10px 0",
                backgroundColor: "#036dda",
                color: "#fff",
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
              }}
            >
              {(this.props.isPopup) ? "Add Permission" : " Update Permission"}
            </DialogTitle>
            <ClearIcon
              style={{
                position: "absolute",
                top: 10,
                right: 10,
                cursor: "pointer",
                color: "#fff",
                backgroundColor: "#f44336",
                borderRadius: "50%",
                padding: "2px",
              }}
              onClick={(e) => { this.props.handleClose() }}
            />
            <DialogContent style={{ padding: "20px", marginTop: "10px" }}>
              <TextField
                className="holiday-form-input"
                helperText={error ? "Cannot be blank" : " "}
                FormHelperTextProps={{ style: { color: error ? '#f44336' : 'inherit' } }}
                error={error}
                name="name"
                label="Add Permission"
                fullWidth
                variant="outlined"
                type="text" value={(this.props.permissionName && this.props.permissionName !== false) ? this.props.permissionName : ""} onChange={(e) => { this.props.updatChange(e) }} />
            </DialogContent>
            <DialogActions style={{ justifyContent: "center", paddingBottom: "20px" }}>
              <Button className="btn-success" color="primary" variant="contained" style={{ textTransform: 'none', backgroundColor: "#036dda", color: "#fff", padding: "6px 24px", borderRadius: "20px" }} onClick={this.handleSave} >{(this.props.isPopup) ? "Save" : "Update"} </Button>
              <Button className="btn-cancel" onClick={(e) => { this.props.handleClose() }} color="default" variant="outlined" style={{ textTransform: 'none', padding: "6px 24px", borderRadius: "20px" }}> Cancel </Button>
            </DialogActions>
          </div>
        </Dialog>
      </div>
    )
  }
}
